module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00032.b5e8eed8.jpg";